import { Component, OnInit, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBar } from '@angular/material/progress-bar';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { CommonService } from '../services/common.service';

import { OviewComponent } from '../order/oview/oview.component';

@Component({
	selector: 'app-list',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.css'],
})
export class ListComponent implements OnInit {

	pageObj:any = "curr";

	logi_user:any;

	frm : FormGroup;

	orderList:any;
	orderCnt:any = [];
	sdate:any;
	edate:any;

	/* 페이징 */
	cp:any = 1;
	paging:any = [];
	paging_start:any = [];
	paging_end:any = [];

	/* 검색관련 */
	skey:any = "";
	sw:any = "";

	autoOrder:any;
	autoProgress:any = 0;


	startDate = new FormControl(new Date());
	endDate = new FormControl(new Date());

	mindate = new Date(new Date().setMonth(new Date().getMonth() - 1));
	maxdate = new Date(new Date().setMonth(new Date().getMonth() + 1));

	@ViewChild('sd') sdElement: ElementRef;
	@ViewChild('ed') edElement: ElementRef;

	constructor(
		private http: HttpClient,
		private env: EnvService,
		private calendar: NgbCalendar,
		public formatter: NgbDateParserFormatter,
		public dialog: MatDialog,

		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = new FormGroup({
			sdate: new FormControl(''),
			edate: new FormControl(''),
			skey: new FormControl(''),
			sw: new FormControl('')
		});
	}

	ngOnInit() {
		this.autoOrder = setInterval(() => {
			this.autoProgress = this.autoProgress + 10;
			if( this.autoProgress > 100 )
			{
				this.autoProgress = 0;
				this.getOrderList(this.cp);
			}
		}, 1000);

		this.cp = this.func.getParameterByName("page", window.location.href);
		if( this.cp == null ){ this.cp = 1; }

		this.sdate = this.func.getParameterByName("sdate", window.location.href);
		if( this.sdate == null ){ this.sdate = this.sdElement.nativeElement.value; }
		else{ this.frm.get('sdate').setValue(this.sdate); this.startDate = new FormControl(new Date(this.sdate)); }

		this.edate = this.func.getParameterByName("edate", window.location.href);
		if( this.edate == null ){ this.edate = this.edElement.nativeElement.value; }
		else{ this.frm.get('edate').setValue(this.edate); this.endDate = new FormControl(new Date(this.edate)); }

		this.skey = this.func.getParameterByName("skey", window.location.href);
		if( this.skey == null ){ this.skey = ""; }

		this.sw = this.func.getParameterByName("sw", window.location.href);
		if( this.sw == null ){ this.sw = ""; }
	}

	ngAfterViewInit() {
		this.getOrderList(this.cp);
	}

	ngOnDestroy() {
		clearInterval(this.autoOrder);
	}

	async getOrderList(num) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("page", num);
		formData.append("skey", this.skey);
		formData.append("sw", this.frm.get('sw').value);
		formData.append("sdate", this.sdElement.nativeElement.value);
		formData.append("edate", this.edElement.nativeElement.value);

		this.http.post(this.env.API_URL + 'api/order.list2.php', formData).subscribe((response) => {
			this.orderList = response['list'];
			this.orderCnt = response['cnt'];

			this.paging = response['paging']['pnum'];
			this.paging_start = response['paging']['start'];
			this.paging_end = response['paging']['end'];
		});
	}

	async oview(idx) {
		const modal = this.dialog.open(OviewComponent,{
			panelClass: 'openwrite-class',
			maxWidth: '1100px',
			disableClose: true,
			data: {
				idx: idx
			},
		});

		modal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['refresh'] == "1" )
				{
				}
			}
		});
	}

	selectPage( num, ev ) {
		this.getOrderList(num);
		this.cp = num;

		let sc_params = "";

		if( this.skey ){ sc_params += "&skey="+this.skey; }
		if( this.sw ){ sc_params += "&sw="+this.sw; }

		history.pushState(null, document.title, window.location.pathname+"?page="+num+sc_params);
	}

	async excel() {
		this.logi_user = await this.authService.getToken();

		var sdate = this.sdElement.nativeElement.value;
		var edate = this.edElement.nativeElement.value;

		window.open(
			this.env.API_URL + 'excel/order.php?user='+this.logi_user+'&code='+this.env.COM_CODE+'&sdate='+sdate+'&edate='+edate+'&sw='+this.frm.get('sw').value,
			'EXCELDOWNLOAD',
			'toolbar=no,scrollbars=no,resizable=no,top=100,left=500,width=600,height=400');
	}

}
